// extracted by mini-css-extract-plugin
export var flexItem = "sponsor-module--flexItem--2huRK";
export var slider_item = "sponsor-module--slider_item--1qgc2";
export var slider_item_outer = "sponsor-module--slider_item_outer--EINg6";